import type { SVGProps } from 'react';
const SiBinoculars = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M10.2047 17C10.2047 17 10.5 15.75 12 15.75M12 15.75C13.5 15.75 13.7953 17 13.7953 17M12 15.75V9.75M19.25 16.25V16.1764C19.25 16.059 19.2397 15.9419 19.2191 15.8263L17.8366 8.04987C17.4972 6.14075 15.8374 4.75 13.8984 4.75H10.1016C8.16256 4.75 6.50276 6.14075 6.16336 8.04987L4.78088 15.8263C4.76033 15.9419 4.75 16.059 4.75 16.1764V16.25M10.25 16.5C10.25 18.0188 9.01878 19.25 7.5 19.25C5.98122 19.25 4.75 18.0188 4.75 16.5C4.75 14.9812 5.98122 13.75 7.5 13.75C9.01878 13.75 10.25 14.9812 10.25 16.5ZM19.25 16.5C19.25 18.0188 18.0188 19.25 16.5 19.25C14.9812 19.25 13.75 18.0188 13.75 16.5C13.75 14.9812 14.9812 13.75 16.5 13.75C18.0188 13.75 19.25 14.9812 19.25 16.5Z"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SiBinoculars;
